<template>
  <div class="page-content">
    <div class="page-title">Global List</div>
    <div class="text">Global List of Associations and Clubs for UNESCO</div>
    <div class="scrollBox">
<!--      <pdf v-for="item in numPages" :key="item" :src="pdfUrl" :page="item" ref="pdf"></pdf>-->
    </div>
<!--    <iframe src=""></iframe>-->
    <iframe class="pdf-iframe" src="/Global List of Associations and Clubs for UNESCO_20251125.pdf" frameborder="0" scrolling="no" style="display: block;"></iframe>
  </div>
</template>
<script>
import pdf from "vue-pdf";
export default {
  components: {
    pdf,
  },
  data() {
    return {
      /***
      如果pdf在本地，pdf需要放在public文件夹中，引用时不能使用相对路径，且‘/’即表示public文件夹(需略去public)
      如 src=" /public/static/book1.pdff" 这样就会报错如下，应该是src="/static/book1.pdf"
      ***/
      // pdfSrc: "/Global List of Associations and Clubs for UNESCO_20240206.pdf",
      //1.pdf name:Global List of Associations and Clubs for UNESCO_20240206
      // pdfSrc: "/1.pdf",
      pdfUrl : null,

      numPages: 243, // pdf 总页数
    };
  },
  mounted() {
    // this.getNumPages();
  },
  methods: {
    // # 计算pdf页码总数
    getNumPages() {
      this.pdfUrl  = pdf.createLoadingTask("/Global List of Associations and Clubs for UNESCO_20251125.pdf");
      this.pdfUrl.promise
        .then((pdf) => {
          this.numPages = pdf.numPages;
        })
        .catch((err) => {
          console.error("pdf 加载失败", err);
        });
    },
    // pdf加载时
    loadPdfHandler(e) {
      console.log(e);
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>

.page-content {
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(54vh, pc);
    text-align: justify;
    margin-bottom: fh(20vh, pc);
  }
  > img {
    width: 100%;
    display: block;
  }
  .sub-title {
    margin: fh(20vh, pc) 0;
    font-size: fh(24vh, pc);
    line-height: fh(54vh, pc);
    font-weight: bold;
    color: #333333;
  }
  .text {
    // margin-top: fh(55vh, pc);
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(28vh, pc);
  }
  .more-btn {
    margin: fh(50vh, pc) auto;
  }
}
</style>
